import axios from '@/common/utils/axios'
import { strictParse } from '@/common/utils/parsing-utils/strict-parse'
import {
  UnreadMessagesCounterResponse,
  ChatsPaginatedResponse,
  MessagesPaginatedResponse,
} from '../types/conversations-data-parsers'
import type { AxiosRequestConfig } from 'axios'
// TODO: temp, uncomment for testing
// import { whatsappChatsFactory, whatsappMessagesFactory } from '../fixtures/whatsapp-conversations.fixture'

/**
 * Will return a number from 0 to 100
 * (for performance reasons 100 is the highest number, since we only display 99+ for this counter)
 */
export const fetchUnreadMessagesCount = async () => {
  const { data } = await axios.get<UnreadMessagesCounterResponse>('/xhr/notify/whatsapp/messages/unread')
  const { count } = strictParse(data, UnreadMessagesCounterResponse, 'fetchUnreadMessagesCount')
  return count
}

type FetchChatsPayload = {
  cursor: string | null
}

// TODO: temp, uncomment for testing
// let maxMessageCalls = 5
// let maxChatCalls = 5

export const fetchChats = async (
  { cursor }: FetchChatsPayload,
  config?: AxiosRequestConfig<FetchChatsPayload>,
): Promise<ChatsPaginatedResponse> => {
  // TODO: temp, uncomment for testing
  // await new Promise(res => setTimeout(() => res(null), 1000))
  // const chatsFix = whatsappChatsFactory()
  // return {
  //   data: chatsFix,
  //   next: --maxChatCalls ? 'next-cursor' : null,
  //   previous: --maxChatCalls ? 'prev-cursor' : null,
  // }

  const url = cursor || '/xhr/notify/whatsapp/chats'
  const response = await axios.get<ChatsPaginatedResponse>(url, {
    ...config,
    // cursor link already contains baseUrl
    ...(cursor && { baseURL: '' }),
  })

  const { data, next, previous } = strictParse(response.data, ChatsPaginatedResponse, 'fetchWhatsAppChatsPage')
  return { data, next, previous }
}

type FetchMessagesPayload = {
  chatId: string
  cursor: string | null
}
export const fetchMessages = async (
  { chatId, cursor }: FetchMessagesPayload,
  config?: AxiosRequestConfig<FetchMessagesPayload>,
): Promise<MessagesPaginatedResponse> => {
  // TODO: temp: uncomment for testing
  // await new Promise(res => setTimeout(() => res(null), 1000))
  // const messagesFix = whatsappMessagesFactory(20)
  // return {
  //   data: messagesFix,
  //   next: --maxMessageCalls ? 'next-cursor' : null,
  //   previous: --maxMessageCalls ? 'prev-cursor' : null,
  // }

  const url = cursor || `/xhr/notify/whatsapp/chats/${chatId}/messages`

  const response = await axios.get<MessagesPaginatedResponse>(url, {
    ...config,
    // cursor link already contains baseUrl
    ...(cursor && { baseURL: '' }),
  })

  const { data, next, previous } = strictParse(response.data, MessagesPaginatedResponse, 'fetchWhatsAppMessagesPage')
  return { data, next, previous }
}
